import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';

export const updateAppStatus = async (activateApp: boolean) => {
    const pbClient = new ProtobufClient(goBackendApi());

    const url = activateApp ? '/api/v1/settings/app/activate' : '/api/v1/settings/app/deactivate';

    return pbClient.putRequest(null, null, url).then((res) => res);
};
